import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { FC } from "react";
import { FlexFieldScreenFieldset } from "../../../components/FlexFieldScreenFieldset";

export interface IFlexFieldScreenFieldsetPage {}

export const FlexFieldScreenFieldsetPage: FC<IFlexFieldScreenFieldsetPage> =
  () => {
    return (
      <AuthenticatedLayout
        pageTitle="Flex Field Screen Setup"
        breadcrumbCurrentPageName=""
        breadcrumbLinks={[]}
        mainContents={
          <FlexFieldScreenFieldset testId="flex-field-screen-setup" />
        }
      />
    );
  };
